import Cookies from 'js-cookie';
import { getToken, removeToken, setToken } from '../../utils/index';
import {
  login,
  getUserInfo,
  //  logOut,
  changePwd,
} from '../../api/auth';

const initState = {
  token: getToken(),
  username: '',
  name: '',
  phone: '',
  openId: '',
  passwordState: false,
  roles: [],
  export: 0,
  // userInfo只会获取一次接口，标记判断
  isGetUserInfo: false,
};

const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  SET_STATE(state, payload) {
    Object.assign(state, payload);
  },
};
const actions = {
  // 登录
  async Login({ commit }) {
    try {
      const params = new FormData();
      params.append('username', 'user');
      params.append('password', '123456');
      const { data } = await login();
      commit('SET_STATE', data);
      setToken(data.token);
    } catch (err) {
      throw new Error(err);
    }
  },

  // 获取用户信息
  async GetUserInfo({ commit }) {
    try {
      const { data } = await getUserInfo();

      commit('SET_STATE', {
        id: data.id,
        openId: data.openId,
        passwordState: data.passwordState,
        phone: data.phone,
        username: data.username,
        name: data.realName,
        isGetUserInfo: true,
        roles: data.roleList,
        export: data.export,
      });

      Cookies.set('username', data.username);
      Cookies.set('name', data.realName);
      Cookies.set('phone', data.phone);
      Cookies.set('roles', data.roleList);
      window.localStorage.setItem('menuList', JSON.stringify(data.menuList || []));
    } catch (err) {
      throw new Error(err);
    }
  },

  async logout({ commit }) {
    commit('SET_STATE', JSON.parse(JSON.stringify(JSON.parse(JSON.stringify(initState)))));
    removeToken();
    Cookies.remove('username');
    Cookies.remove('name');
    Cookies.remove('phone');
    Cookies.remove('ticket'); // 后端加的
  },

  ChangePwd(state, params) {
    // eslint-disable-line
    // try {
    //     const { data } = await changePwd(params);
    //     return data;
    // } catch (err) {
    //     throw new Error(err);
    // }
    return new Promise((resolve, reject) => {
      changePwd(params)
        .then((response) => {
          const { code, msg } = response;
          const data = {
            success: true,
          };
          if (code === 0) {
            resolve(data);
          } else {
            reject(msg);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  name: 'user',
  namespaced: true,
  state,
  mutations,
  actions,
};
